module.exports = __webpack_public_path__ + "img/Image5@2x.92a22f6e.jpg";